<div class="px-5 mt-4">
  <h1>Technical Support</h1>
  @if (!requestSubmitted) {
    <div>
      <div class="m-2 mt-3 lg:w-3/5">
        <p>{{ 'Technical support requests are to assist with issues relating to locally saved audits. This should only be used when requested by Care Audits support.' | customerText }}</p>
      </div>
      <div class="mt-4">
        <textarea  class="w-full lg:w-3/5" placeholder="Enter Details" [(ngModel)]="extraDetails"></textarea>
      </div>
      <p class="my-3 italic mx-2">**Please note all your local Care Audits information will be sent with this request.**</p>
     
    <div class="mt-6">
      <button class="btn-primary w-full lg:w-3/5" [disabled]="!validateSend() || sendingRequest" (click)="sendRequest()">
        @if (sendingRequest) {
          <i class="pi pi-spinner pi-spin text-xs"></i>
        }
        {{ sendingRequest ? 'Sending Support Request...' : 'Submit Support Request' }}
      </button>
    </div>
  </div>
}

@if (requestSubmitted) {
  <div class="my-3 mx-2">
    <p>Your request has been submitted succesfully</p>
  </div>
}
</div>
